// Possible duplicates (founder decision 2026-10-13, backend utils/dupeFlag):
// the words the list uses, in one place so the page and its tests agree.
// Review only: nothing on that page changes an account.
import { formatEt } from "./introPauseUtils";

export { formatEt };

// The list's filter, in the order the founder works through it.
export const STATE_FILTERS = [
  { value: "new", label: "New" },
  { value: "reviewed", label: "Reviewed" },
  { value: "dismissed", label: "Not the same person" },
  { value: "all", label: "All" },
];

export const stateLabel = (state) => {
  const hit = STATE_FILTERS.find((s) => s.value === state);
  return hit ? hit.label : "";
};

// "Toronto, waitlist", "Ottawa, active", or "No city" when there is none.
const POCKET_STATES = { waitlist: "waitlist", active: "active", out_of_pocket: "outside every city" };
export const pocketLabel = (account) => {
  const p = (account && account.pocket) || {};
  const state = POCKET_STATES[p.state] || null;
  if (p.name) return state ? `${p.name}, ${state}` : p.name;
  return state === "outside every city" ? "Outside every city" : "No city";
};

// What the face check and the email say, as two short facts.
export const verificationLabels = (account) => {
  const v = (account && account.verification) || {};
  const out = [];
  if (v.face) out.push(v.faceRecheck === "mismatch" ? "Face check passed, later recheck did not" : "Face check passed");
  else out.push("Face check not passed");
  out.push(v.email ? "Email verified" : "Email not verified");
  return out;
};

// A word about the account itself, when there is one to say.
export const accountNote = (account) => {
  if (!account || account.exists === false) return "Account permanently deleted";
  if (account.deleted) return "Deleted";
  if (account.status === "banned") return "Banned";
  if (account.status === "suspended") return "Suspended";
  if (!account.onboarded) return "Has not finished sign-up";
  return null;
};
